import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { verifyCode } from "../api/code";
import Cookies from "js-cookie"; // Import js-cookie library
import { Bounce, toast } from "react-toastify";

export const varifyCodeData = createAsyncThunk(
  "varify/varifyCodeData",
  async ({ otp }, { rejectWithValue }) => {
    try {
      const sessionExpired = (msg) => {
        toast(msg, {
          style: {
            background: "#f87171",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "2rem",
            padding: "1rem",
            width: "20dvh",
          },
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
          transition: Bounce,
          closeButton: ({ closeToast }) => (
            <button
              className="text-white text-4xl leading-none rounded-full p-2"
              onClick={closeToast}
            >
              ×
            </button>
          ),
        });
      };
      const phone = sessionStorage.getItem("phone");
      // const code = sessionStorage.getItem("code");
      const { data } = await verifyCode({ phone, otp }); // Call the API function
      if (!data?.status && data?.message == "user.register code expire") {
        sessionExpired("Session has expired");

        setTimeout(() => {
          window.location.href = "/logout";
        }, 3000);
        return Promise.reject(
          new Error("Branch ID is missing. Redirecting to logout.")
        );
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message); // Handle errors properly
    }
  }
);

const initialValues = {
  customerId: null,
  isLoading: false,
  isError: null,
};

const codeVerifySlice = createSlice({
  name: "varify",
  initialState: initialValues,
  extraReducers: (builder) => {
    builder
      .addCase(varifyCodeData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customerId = action.payload;
        // sessionStorage.setItem(
        //   "customer_id",
        //   action.payload?.data?.customer_id
        // );
        // sessionStorage.setItem("token", action.payload?.data?.user_kiosk_token);
        Cookies.set(
          "user_kiosk_token",
          action.payload?.data?.user_kiosk_token,
          {
            secure: true,
          }
        );
        Cookies.set("customer_id", action.payload?.data?.customer_id, {
          secure: true,
        });
        // console.log(action.payload);
      })
      .addCase(varifyCodeData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(varifyCodeData.rejected, (state, action) => {
        state.isError = action.error;
        state.isLoading = false;
        // console.log(action.error);
      });
  },
  reducers: {},
});

export const codeVerifyReducer = codeVerifySlice.reducer;
